import { Injectable } from '@angular/core';
import { SortEnum } from '../enum/sortEnum.enum';
import { GetDocumentFiltersCommand, IGetDocumentFiltersParameters } from './command/get-document-filters.command';
import { GetDocumentTypesCommand, IGetDocumentTypesParameters } from './command/get-document-types.command';
import { GetDocumentsCommand, IGetDocumentsParameters } from './command/get-documents.command';
import { ConnectionServices } from '../authentication/connection/connection.service';
import { map } from 'rxjs';

@Injectable()
export class DocumentationService {
  constructor(
    private connectionService: ConnectionServices
  ) {}

  public getDocuments(
    carrierUserId: string,
    module: string,
    document: string,
    page: number,
    size: number,
    column: string,
    sort: SortEnum,
    find?: string
  ) {
    let parameters = new GetDocumentsCommand();
    parameters.setParameters(<IGetDocumentsParameters> {
      carrierUserId: carrierUserId,
      column: column,
      page: page,
      size: size,
      sort: sort,
      find: find,
      module: module,
      document: document
    });

    return this.connectionService
      .Request(parameters)
      .pipe(
        map((response: any) => {
          return response;
        })
      )
  }

  public getFilterTypes(carrierUserId: string) {
    let parameters = new GetDocumentFiltersCommand();
    parameters.setParameters(<IGetDocumentFiltersParameters> {
      carrierUserId: carrierUserId
    });

    return this.connectionService
      .Request(parameters)
      .pipe(
        map((response: any) => {
          return response;
        })
      )
  }

  public getDocumentTypes(module: string) {
    let parameters = new GetDocumentTypesCommand();
    parameters.setParameters(<IGetDocumentTypesParameters> {
      module: module
    });

    return this.connectionService
      .Request(parameters)
      .pipe(
        map((response: any) => {
          return response;
        })
      )
  }
}
